import React from 'react';
import styled from 'styled-components';
import { Snackbar, Alert, Slide } from '@mui/material';
import { 
    CheckCircle as CheckCircleIcon, 
    Notifications as NotificationIcon,
    Error as ErrorIcon,
    Info as InfoIcon,
    Warning as WarningIcon
} from '@mui/icons-material';
import { useToast } from '../context/ToastContext';

const StyledSnackbar = styled(Snackbar)`
    top: 24px !important;
    right: 24px !important;
    left: auto !important;
`;

const PremiumAlert = styled(Alert)`
    border-radius: 20px !important;
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(15px) !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.2) !important;
    border: 1px solid rgba(255, 255, 255, 1) !important;
    padding: 16px 28px !important;
    min-width: 320px;
    
    .MuiAlert-icon { 
        font-size: 28px; 
        margin-right: 16px; 
    }
    
    .MuiAlert-message { 
        font-weight: 800; 
        color: #1e293b; 
        font-size: 1rem; 
        padding-top: 4px;
    }

    /* Style based on severity */
    &.MuiAlert-standardSuccess .MuiAlert-icon { color: #10b981; }
    &.MuiAlert-standardError .MuiAlert-icon { color: #f43f5e; }
    &.MuiAlert-standardInfo .MuiAlert-icon { color: #0ea5e9; }
    &.MuiAlert-standardWarning .MuiAlert-icon { color: #f59e0b; }
`;

function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
}

const getIcon = (severity) => {
    switch (severity) {
        case 'success': return <CheckCircleIcon />;
        case 'error': return <ErrorIcon />;
        case 'warning': return <WarningIcon />;
        case 'info': return <InfoIcon />;
        default: return <NotificationIcon />;
    }
};

const PremiumToast = () => {
    const { toast, hideToast } = useToast();

    return (
        <StyledSnackbar 
            open={toast.open} 
            autoHideDuration={4000} 
            onClose={hideToast}
            TransitionComponent={TransitionLeft}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <PremiumAlert 
                onClose={hideToast} 
                severity={toast.severity}
                icon={getIcon(toast.severity)}
            >
                {toast.message}
            </PremiumAlert>
        </StyledSnackbar>
    );
};

export default PremiumToast;
